export default "__VITE_ASSET__DMhUcPjs__"